import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=8478d274&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=8478d274&prod&lang=scss"
import style1 from "./CategoryTree.vue?vue&type=style&index=1&id=8478d274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8478d274",
  null
  
)

export default component.exports